import {
    AdLoadingStrategyTypeEnum,
    AdSizes,
    AdUnit,
    AdUnitSpecialUseCaseEnum,
    AdUnitTypeEnum,
    PageAdsBuilder
} from "@repo/lib-domain-tag";
import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil, pageUtil } from "@repo/lib-common";
import { mobileOutOfPageAdUnit } from "../../commonAdUnits/outOfPageAdUnits";

export class MobileHoroscopeReviewPageAdsBuilder extends PageAdsBuilder {
    override init() {
        this.setIsEnabled(true);

        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_m_gen_masthead")
                .setDivId("div-sozcu_m_gen_masthead")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.sra)
                .setSizes(AdSizes.mobile_Generic)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_m_gen_masthead' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );



        this.applyAdUnit(
            AdUnit.builder(AdUnitTypeEnum.banner)
                .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
                .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
                .setIsEnabled(true)
                .setAdUnitPath("/66738120/sozcu_mobil_footer")
                .setDivId("div-sozcu_mobil_footer")
                .setDivStyleAfterRequest('')
                .setLoadingStrategy(AdLoadingStrategyTypeEnum.intersectionObserverBasedLazyLoad)
                .setSizes(AdSizes.mobile_Generic)
                .setIsAutoRefreshEnabled(true)
                .setIsPrebidEnabled(true)
                .setPrebidSizeLimits(AdSizes.prebid_300x250)
                .setBidderHelper(pageBidderHelper)
                .setBidderCustomParam('taboola', { tagId: 'sozcu_mobil_footer' })
            //.onSlotRenderEnded(fixPageSkinCssClass)

        );



        mobileOutOfPageAdUnit.forEach(adUnit => {
            this.applyAdUnit(adUnit);
        });

        // if (domainCountry === CountryEnum.usa) {
        //     this.applyAdUnit(
        //         AdUnit.builder(AdUnitTypeEnum.outOfPage_BottomAnchor)
        //             .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        //             .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        //             .setIsEnabled(true)
        //             .setAdUnitPath("/66738120/sozcu_anchor_ads")
        //             //.setDivId("div-sozcu_anchor_ads")
        //             //.setDivStyleAfterRequest('')
        //             .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        //             .setSizes(AdSizes.general_1x1)
        //             .setIsAutoRefreshEnabled(true)
        //             .setIsPrebidEnabled(false)
        //         //.setPrebidSizeLimits([])
        //         //.setBidderHelper(pageBidderHelper)
        //     );
        // }

    }
}

export const mobileHoroscopeReviewPageAdsBuilder = new MobileHoroscopeReviewPageAdsBuilder(deviceUtil.DeviceTypeEnum.mobile, pageUtil.PageTypeEnum.postDetail);


